// Common currency symbols mapping
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CAD: "$",
  AUD: "$",
  NZD: "$",
  SGD: "$",
  HKD: "$",
  CHF: "CHF",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  CZK: "Kč",
  HUF: "Ft",
  RUB: "₽",
  CNY: "¥",
  INR: "₹",
  KRW: "₩",
  THB: "฿",
  MYR: "RM",
  PHP: "₱",
  VND: "₫",
  IDR: "Rp",
  BRL: "R$",
  MXN: "$",
  ARS: "$",
  CLP: "$",
  COP: "$",
  PEN: "S/",
  ZAR: "R",
  EGP: "£",
  MAD: "DH",
  TND: "د.ت",
  KES: "KSh",
  NGN: "₦",
  GHS: "₵",
  XOF: "CFA",
  XAF: "FCFA",
};

/**
 * Get currency symbol from currency code
 */
export function getCurrencySymbol(currencyCode: string): string {
  // First, try to get from our manual mapping
  const symbol = CURRENCY_SYMBOLS[currencyCode];
  if (symbol) {
    return symbol;
  }

  // Fallback to Intl.NumberFormat for other currencies
  try {
    const formatter = new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Format 0 and extract just the symbol by removing the number
    const formatted = formatter.format(0);
    const extractedSymbol = formatted.replace(/[\d\s,]/g, "").trim();

    return extractedSymbol || currencyCode;
  } catch (_error) {
    // Fallback to currency code if formatting fails
    return currencyCode;
  }
}

/**
 * Get currency symbol for current salon
 */
export function getSalonCurrencySymbol(salonCurrency?: string): string {
  const currency = salonCurrency || "USD";
  return getCurrencySymbol(currency);
}
